import { WorkloadContextData } from './types';
import {
  addBusinessDays,
  differenceInBusinessDays,
  lastDayOfMonth,
  lastDayOfWeek,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

export const getFirstDayOfBusinessWeek = (date: Date): Date =>
  startOfWeek(date, { weekStartsOn: 1 });

export const getLastDayOfBusinessWeek = (date: Date): Date =>
  lastDayOfWeek(date, { weekStartsOn: 0 });

export const getInitialDate = (date: Date) => {
  const firstDayOfWeek = getFirstDayOfBusinessWeek(date);
  return addBusinessDays(firstDayOfWeek, differenceInBusinessDays(date, firstDayOfWeek));
};
const getFirstDate = (date: Date) => getFirstDayOfBusinessWeek(startOfMonth(date));

const getLastDate = (date: Date) => getLastDayOfBusinessWeek(lastDayOfMonth(date));

export const MONTHLY_LIMIT = 5;
export const TWO_WEEKLY_LIMIT = 10;

export const initialState: WorkloadContextData = {
  setData: () => {},
  visibleDays: 8,
  cellWidth: 0,
  date: getInitialDate(new Date()),
  dates: [],
  calendar: {
    isLoading: true,
    records: [],
  },
  sidebar: {
    isLoading: true,
    records: [],
  },
  isTwoWeekly: false,
  monthly: {
    records: {},
    isLoading: true,
    weekLength: 6,
    limit: MONTHLY_LIMIT,
    first: getFirstDate(new Date()),
    last: getLastDate(new Date()),
    dates: [],
  },
};
